<template>
  <modal
    no-bg-close
    v-bind="{ title }"
    footer-class="is-block"
    card-class="auto-width">
    <div ref="cropper"/>
    <div class="buttons is-centered" slot="footer">
      <action-button
        class="is-primary is-rounded"
        v-bind="{ working }"
        @click="handle">
        Crop &amp; Upload
      </action-button>
    </div>
  </modal>
</template>

<script>
import { ImageCropper } from '@/utils/image-cropper'
import { readFile } from '@/utils/file-reader'

export default {
  props: {
    title: {
      type: String,
      default: 'Crop image'
    },
    file: File
  },

  data: () => ({
    cropper: null,
    working: false,
  }),

  mounted() {
    readFile(this.file).then(result => {
      this.cropper = new ImageCropper(this.$refs.cropper, result)
    })
  },

  methods: {
    handle() {
      let canvas = this.cropper.crop('image/jpeg')
      canvas.toBlob(result => {
        this.working = true
        this.callback(result).then(() => {
          this.$close(true)
        }).catch(() => {
          this.$toast.error('Something went wrong. Please try again or contact support.')
        }).finally(() => {
          this.working = false
        })
      })
    }
  }
}
</script>
